import { useEffect } from "react";
import { useTenant } from "@/hooks/useTenant";
import { buildDocumentTitle } from "@/lib/document-title";

/** Keeps the browser tab title in sync with the active environment. */
export function DocumentTitleSync() {
  const { activeTenant } = useTenant();

  useEffect(() => {
    document.title = buildDocumentTitle(activeTenant);
  }, [activeTenant]);

  return null;
}
